import 'dayjs/locale/en'
import 'dayjs/locale/pt'
import 'dayjs/locale/es'

import '../../../assets/fonts.css'

import '@mantine/core/styles.layer.css'
import '@mantine/dates/styles.layer.css'
import '@mantine/notifications/styles.layer.css'
import '@mantine/nprogress/styles.layer.css'
import '@mantine/tiptap/styles.layer.css'
import '@mantine/carousel/styles.layer.css'
import '@mantine/code-highlight/styles.layer.css'
import 'mantine-datatable/styles.layer.css'

import './MantineThemeProvider.css'

import { MantineProvider, type MantineThemeOverride } from '@mantine/core'
import { ModalsProvider } from '@mantine/modals'
import { Notifications } from '@mantine/notifications'
import { NavigationProgress } from '@mantine/nprogress'
import { type PropsWithChildren } from 'react'

import { useMantineTheme } from './useMantineTheme'

export type MantineThemeProviderProps = PropsWithChildren & {
  themeOverride?: MantineThemeOverride
}

export function MantineThemeProvider({
  children,
  themeOverride,
}: MantineThemeProviderProps) {
  const theme = useMantineTheme(themeOverride)

  return (
    <MantineProvider theme={theme} withCssVariables>
      <ModalsProvider>
        <NavigationProgress zIndex={99999} />
        <Notifications zIndex={99999} />
        {children}
      </ModalsProvider>
    </MantineProvider>
  )
}
